import React, { useContext } from 'react';
import { Box, FormControlLabel, Checkbox, Grid, IconButton, Tooltip, Typography, debounce } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';

import EndDateRadioCard from './Cards/EndDateRadioCard';
import CustomOptionsCard from './Cards/CustomOptionsCard';
import FrequencySelector from './Cards/FrequencySelector';
import { RecurringSx as sx } from './RecurringItem.style';
import SchedulingContext from '../../../SchedulingContext';
import AutoIncrementorOptionsCard from '../AutoIncrementor/AutoIncrementorOptionsCard';
import PreviewTableCard from './Cards/PreviewTableCard';

const OptionGrid = ({ children, show, spacing }) => {
    if (!show) return null;

    return (
        <Box sx={{ padding: (theme) => theme.spacing(1), backgroundColor: 'rgba(0,0,0,0.05)' }}>
            <Grid container>{children}</Grid>
        </Box>
    );
};

const RecurringItemHeader = ({ item, setItem, disabled, handleRecurringChange }) => {
    if (item.recurring)
        return (
            <Box sx={(theme) => sx(item.recurring)(theme).headerBox}>
                <Box sx={(theme) => sx(item.recurring)(theme).closeBox}>
                    <Tooltip title="Remove Repeat. This resets all selected options." arrow>
                        <IconButton size="small">
                            <CloseOutlined onClick={() => handleRecurringChange({ target: { value: false } })} />
                        </IconButton>
                    </Tooltip>
                    <Typography variant="body1">Repeat</Typography>
                </Box>
                <FrequencySelector item={item} setItem={setItem} disabled={disabled} />
            </Box>
        );

    return (
        <Box sx={(theme) => sx(theme).headerBox}>
            <Box sx={(theme) => sx(item.recurring)(theme).mainCheckbox}>
                <FormControlLabel
                    disabled={disabled} // Wrap
                    control={<Checkbox fullWidth checked={item.recurring} value={item.recurring} onChange={handleRecurringChange} />}
                    label="Repeat"
                />
            </Box>
        </Box>
    );
};

function RecurringItemFields({ hide, item, setItem, disabled = false, handleRecurringChange }) {
    if (hide) return null;
    const {
        properties: {
            canUseAutoIncrement: { enabled: autoEnabled },
        },
    } = useContext(SchedulingContext);

    return (
        <Box sx={(theme) => sx(item.recurring)(theme).wrap} display="flex" flexDirection="column">
            <Box sx={(theme) => sx(item.recurring)(theme).subBox}>
                <RecurringItemHeader item={item} setItem={setItem} disabled={disabled} handleRecurringChange={handleRecurringChange} />
                <OptionGrid show={item.recurring} spacing={2} disabled={disabled}>
                    <Grid item xs={12} container spacing={1} sx={{ margin: 0 }}>
                        <Grid item xs={5} order={autoEnabled ? 2 : 1}>
                            <EndDateRadioCard item={item} setItem={setItem} disabled={disabled} />
                        </Grid>
                        <Grid item="item" xs={autoEnabled ? 12 : 7} order={autoEnabled ? 1 : 2}>
                            <CustomOptionsCard item={item} setItem={setItem} disabled={disabled} />
                        </Grid>

                        {autoEnabled && (
                            <Grid item="item" xs={7} order={3}>
                                <AutoIncrementorOptionsCard item={item} setItem={setItem} order={3} />
                            </Grid>
                        )}
                        <Grid item="item" xs={12} order={4}>
                            <PreviewTableCard item={item} />
                        </Grid>
                    </Grid>
                </OptionGrid>
            </Box>
        </Box>
    );
}

export default RecurringItemFields;
